

import { authHeader } from '../helpers/authHeader';
import apiClient from '../helpers/apiClient';


export const accountService = {
  getAccountInvoice,
  getPaymentLink,
  getAccountEstimate,
  getReoccuring,
  getExpense,
  getReOccuringExpense,
  getProject,
  getJournal,
  getChartOfAccount,
  getChartEntryMasterData,
  saveNewChartAccount,
  getChartOfAccountDetails,
  getChartOfAccountCurrencies,
  getConversionRate,
  updateAccountStatus,
  getPaymentReceiveList,
  savePaymentReceivedTableMenu,
  getPaymentReceiveDetails,
  savePaymentReceivedBulkAction,
  getPaymentEntryData,
  submitPaymentReceived,
  getPurchaseOrderList,
  savePaymentPurchaseOrderTableMenu,
  setPurchaseBulkAction,
  getPurchaseDetails,
  getPurchaseBill,
  getPurchaseReceives,
  getPurchaseEntryMasterData,
  getPurchaseHistory,
  submitPurchaseOrder,
  deletePaymentReceive,
  getPaymentGatewayListByDate,
  getPaymentVariate,
  walletCheckDetails,
  manualJournal,
  manualJournalDetails,
  createNewJournal,
  deleteManualJournal,
  journalAction,
  getChartOfAccountOpeningBalance,
  getBankChargeData,
  updateOpeningBalance,
  getExpenseMainList,
  submitExpense,
  expenseDetails,
  deleteExpense,
  mapAccountData,
  mappedAccountByTransType,
  submitMappedAccount,
  getAccountClass,
  getSingleAccountClass,
  submitNewAccountClass,
  createNewAccountClass,
  deleteAccountClass,
  updateBankCharges,
  getManualJournalByData,
  searchManualJournel,
  getExpenseByDate,
  searchExpense,
  paymentReceiveByDate,
  paymentReceiveSearch,
  rePostManualJournal,
  purchaseAction,
};


async function  paymentReceiveByDate(form) {
    return  apiClient.post(`/accounts/payment-receive-by-date`, form, authHeader());
}
async function  paymentReceiveSearch(searchText) {
    return  apiClient.get(`/accounts/payment-receive-search?search=${searchText}`, authHeader());
}


async function  getAccountClass( ) {
    return  apiClient.get(`/accounts/get-account-class`, authHeader());
}


async function  createNewAccountClass(body ) {
    return  apiClient.post(`/accounts/get-account-class`, body, authHeader());
}



async function  getSingleAccountClass(id) {
    return  apiClient.get(`/accounts/get-account-class/${id}`, authHeader());
}



async function  deleteAccountClass(id) {
    return  apiClient.delete(`/accounts/get-account-class/${id}`, authHeader());
}



async function  submitNewAccountClass(form) {
    return  apiClient.post(`/accounts/get-account-class`,form, authHeader());
}


async function  getAccountInvoice( customer_id) {
    return  apiClient.get(`/accounts/account-invoice/${customer_id}`, authHeader());
}

async function  mapAccountData( ) {
    return  apiClient.get(`/accounts/map-account-data`, authHeader());
}


async function  mappedAccountByTransType(typeId ) {
    return  apiClient.get(`/accounts/map-account-trans-type/${typeId}`, authHeader());
}

async function  submitMappedAccount(data ) {
    return  apiClient.post(`/accounts/submit-mapped-account`, data, authHeader());
}


async function  getPaymentLink( customer_id) {
    return  apiClient.get(`/accounts/payment-link/${customer_id}`, authHeader());
}


async function  createNewJournal(form) {
    return  apiClient.post(`/accounts/manual-journal`, form, authHeader());
}


async function  journalAction(form) {
    return  apiClient.put(`/accounts/manual-journal-action`, form, authHeader());
}

async function  getChartEntryMasterData( ) {
    return  apiClient.get(`/accounts/get-chart-entry-master-data`, authHeader());
}

async function  saveNewChartAccount(body ) {
    return  apiClient.post(`/accounts/save-new-chart-account`,body, authHeader());
}

async function  updateAccountStatus(body ) {
    return  apiClient.put(`/accounts/update-account-status`,body, authHeader());
}


async function  getChartOfAccountDetails( id) {
    return  apiClient.get(`/accounts/get-chart-account-details/${id}`, authHeader());
}

async function  getChartOfAccountOpeningBalance() {
    return  apiClient.get(`/accounts/account-opening-balance`, authHeader());
}

async function  getBankChargeData() {
    return  apiClient.get(`/accounts/bank-charge`, authHeader());
}


async function  updateBankCharges(data) {
    return  apiClient.put(`/accounts/update-bank-charges`, data, authHeader());
}


async function  updateOpeningBalance(data) {
    return  apiClient.put(`/accounts/update-opening-balance`, data, authHeader());
}

async function  getAccountEstimate( customer_id) {
    return  apiClient.get(`/accounts/account-estimate/${customer_id}`, authHeader());
}


async function  getReoccuring( customer_id) {
    return  apiClient.get(`/accounts/account-reoccuring/${customer_id}`, authHeader());
}

async function  getConversionRate( account_id, curr_id, option) {
    return  apiClient.get(`/accounts/conversion-rate/${account_id}/${curr_id}/${option}`, authHeader());
}


async function  getExpense( customer_id) {
    return  apiClient.get(`/accounts/account-expense/${customer_id}`, authHeader());
}



async function  getReOccuringExpense( customer_id) {
    return  apiClient.get(`/accounts/reoccuring-expense/${customer_id}`, authHeader());
}

async function  getProject( customer_id) {
    return  apiClient.get(`/accounts/get-projects/${customer_id}`, authHeader());
}


async function  getJournal( customer_id) {
    return  apiClient.get(`/accounts/get-journal/${customer_id}`, authHeader());
}

async function  getChartOfAccount() {
    return  apiClient.get(`/accounts/get-chart-of-account`, authHeader());
}

async function  getChartOfAccountCurrencies() {
    return  apiClient.get(`/accounts/get-chart-of-account-currencies`, authHeader());
}

async function  getPaymentReceiveList() {
    return  apiClient.get(`/accounts/get-payment-receive-list`, authHeader());
}

async function  savePaymentReceivedTableMenu(body) {
    return  apiClient.put(`/accounts/save-payment-table-menu`, body, authHeader());
}


async function  savePaymentReceivedBulkAction(body) {
    return  apiClient.put(`/accounts/save-payment-received-bulk-action`, body, authHeader());
}


async function  getPaymentReceiveDetails(ref_id) {
    return  apiClient.get(`/accounts/get-payment-receive-details/${ref_id}`, authHeader());
}

async function  getPaymentEntryData(customer_id) {
    return  apiClient.get(`/accounts/payment-entry-data/${customer_id}`, authHeader());
}

async function  submitPaymentReceived(body) {
    return  apiClient.post(`/accounts/submit-payment-receive`,body, authHeader());
}

async function  getPurchaseOrderList() {
    return  apiClient.get(`/accounts/get-purchase-order`, authHeader());
}

async function  savePaymentPurchaseOrderTableMenu(body) {
    return  apiClient.put(`/accounts/save-purchase-order-table-menu`, body, authHeader());
}


async function  getPurchaseDetails(purchase_id ) {
    return  apiClient.get(`/accounts/get-purchase-details/${purchase_id}`, authHeader());
}

async function purchaseAction(body) {
  return apiClient.put(`/accounts/purchase-action`, body, authHeader());
}

async function  setPurchaseBulkAction(body ) {
    return  apiClient.put(`/accounts/set-purchase-bulk-action`,body, authHeader());
}
async function  getPurchaseBill(purchase_id ) {
    return  apiClient.get(`/accounts/get-purchase-bill/${purchase_id}`, authHeader());
}

async function  getPurchaseReceives(purchase_id ) {
    return  apiClient.get(`/accounts/get-purchase-receives/${purchase_id}`, authHeader());
}

async function  getPurchaseHistory(purchase_id ) {
    return  apiClient.get(`/accounts/get-purchase-history/${purchase_id}`, authHeader());
}

async function  getPurchaseEntryMasterData() {
    return  apiClient.get(`/accounts/get-purchase-entry-master-data`, authHeader());
}

async function  submitPurchaseOrder(body) {
    return  apiClient.post(`/accounts/submit-purchase-order`,body, authHeader());
}

async function  deletePaymentReceive(id) {
    return  apiClient.delete(`/accounts/delete-payment-receive/${id}`, authHeader());
}


async function  getPaymentGatewayListByDate(from_date, to_date) {
    return  apiClient.get(`/accounts/payment-gateway-list/${from_date}/${to_date}`, authHeader());
}


async function  getPaymentVariate() {
    return  apiClient.get(`/accounts/payment-variant`, authHeader());
}



async function  walletCheckDetails(data) {
    return  apiClient.post(`/accounts/wallet-check-details`, data, authHeader());
}


async function  manualJournal() {
    return  apiClient.get(`/accounts/manual-journal`, authHeader());
}


async function  rePostManualJournal(id, typeId) {
    return  apiClient.get(`/accounts/manual-journal/repost/${id}/${typeId}`, authHeader());
}


async function  getManualJournalByData(dateForm) {
    return  apiClient.post(`/accounts/manual-journal-date`,dateForm, authHeader());
}

 async function  searchManualJournel(searchText) {
        return  apiClient.get(`/accounts/journal-by-search?search=${searchText}`, authHeader());
    }

async function  manualJournalDetails(id) {
    return  apiClient.get(`/accounts/manual-journal/${id}`, authHeader());
}


async function  deleteManualJournal(id) {
    return  apiClient.delete(`/accounts/manual-journal/${id}`, authHeader());
}

async function  getExpenseMainList() {
    return  apiClient.get(`/accounts/expenses-list`, authHeader());
}

async function  submitExpense(data) {
    return  apiClient.post(`/accounts/submit-expense`, data, authHeader());
}


async function  expenseDetails(id) {
    return  apiClient.get(`/accounts/expense-detail/${id}`, authHeader());
}


async function  deleteExpense(id) {
    return  apiClient.delete(`/accounts/expense/${id}`, authHeader());
}


async function  getExpenseByDate(dateForm) {
    return  apiClient.post(`/accounts/expense-by-date`,dateForm, authHeader());
}

 async function  searchExpense(searchText) {
        return  apiClient.get(`/accounts/search-expense?search=${searchText}`, authHeader());
    }












